import React from 'react';
import { connect } from 'dva';
import { Heading, Button } from '@mos-cat/typography';
import { Dispatch } from 'redux';
import WarningInfo from './WarningIcon';

import './DraftWarning.pcss';

interface DraftWarningProps {
  onResetForm(): void;
  onRepeatSearch(): void;
}

function DraftWarningComp({
  onResetForm,
  onRepeatSearch,
}: DraftWarningProps): JSX.Element {
  return (
    <div className="DraftWarning">
      <Heading className="DraftWarning__heading" level={2}>
        <WarningInfo className="DraftWarning__icon" />
        <span>Черновики не загружены</span>
      </Heading>
      <div className="DraftWarning__content">
        <p>
          Не удалось загрузить черновики. Если ранее вы заполняли заявление,
          повторите запрос позже или начните оформлять заявления заново.{' '}
        </p>
        <div className="DraftWarning__buttons">
          <Button primary onClick={onRepeatSearch}>
            Повторить поиск черновиков
          </Button>
          <Button primary onClick={onResetForm}>
            Начать оформление заново
          </Button>
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onResetForm: () => dispatch({ type: 'form/reset' }),
  onRepeatSearch: () => dispatch({ type: 'form/getDraft' }),
});

export default connect(undefined, mapDispatchToProps)(DraftWarningComp);
